<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <validated-text-field
          v-model="membership.name"
          field-name="membership_name"
          rules="required"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.winching_price"
          field-name="winching_price"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.towing_price"
          field-name="towing_price"
          :field-name-params="{ currency: profile.organization.currency.name }"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.flight_price"
          field-name="flight_price"
          :field-name-params="{ currency: profile.organization.currency.name }"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.min_price"
          field-name="min_price"
          rules="required"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.full_fee"
          field-name="full_fee"
          :field-name-params="{ currency: profile.organization.currency.name }"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.discount_fee"
          field-name="discount_fee"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.multiplier"
          field-name="multiplier"
          rules="required"
          type="number"
        />
      </v-col>
      <v-col cols="12" md="3">
        <validated-text-field
          v-model="membership.time_limit"
          field-name="time_limit"
          rules="required"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <v-checkbox
          v-model="membership.yearly_membership_fee"
          :label="$t('fields.yearly_membership_fee')"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-checkbox
          v-model="membership.vote"
          :label="$t('fields.vote')"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-checkbox
          v-model="membership.messaging"
          :label="$t('fields.messaging')"
        />
      </v-col>
    </v-row>
    <v-row
      class="mb-3"
    >
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('fields.towing_price_altitude') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container class="py-0 px-5">
              <v-btn
                block
                class="mb-6"
                @click="addBlankTowingPrice"
              >
                {{ $t('add_price') }}
              </v-btn>
              <v-row
                v-for="(price,i) in membership.towing_price_altitude"
                :key="i"
              >
                <v-col cols="6">
                  <validated-text-field
                    v-model="price.altitude"
                    field-name="altitude"
                    rules="required"
                    type="number"
                  />
                </v-col>
                <v-col cols="5">
                  <validated-text-field
                    v-model="price.price"
                    field-name="price"
                    rules="required"
                    type="number"
                  />
                </v-col>
                <v-col
                  cols="1"
                >
                  <v-btn
                    icon
                    color="delete"
                    class="mt-5"
                    @click="removeTowingPrice(price)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'EditMembership',
    props: {
      membership: Object,
    },
    computed: {
      profile: get('auth/profile'),
    },
    methods: {
      removeTowingPrice (item) {
        // console.log(item)
        // console.log('remove' + item.id)
        this.membership.towing_price_altitude.splice(this.membership.towing_price_altitude.indexOf(item), 1)
      },
      addBlankTowingPrice () {
        this.membership.towing_price_altitude.push({
          altitude: null,
          price: null,
        })
      },
    },

  }
</script>
